'use client';

import React, { useEffect } from 'react';
import {
    generateGoogleAnalyticsScript,
    generateFacebookPixelScript,
    TRACK_EVENT,
    logEvent,
    instance as trackingObserver,
} from 'libs/track';
import { PreloadResources } from 'app/PreloadResources';
import { preinit } from 'base/preinit';

export function PerformanceAndTracking(props: { trackingConfig: TrackingConfig }) {
    const { trackingConfig } = props;

    useEffect(() => {
        preinit();

        if (trackingConfig.google_analytics_id) {
            trackingObserver.setGoogleAnalyticsId(trackingConfig.google_analytics_id);
        }

        if (trackingConfig.facebook_pixel_id) {
            trackingObserver.setFacebookPixelId(trackingConfig.facebook_pixel_id);
        }

        if (trackingConfig.google_search_console_content) {
            trackingObserver.setGoogleSearchConsoleContent(
                trackingConfig.google_search_console_content
            );
        }
    }, []);

    useEffect(() => {
        logEvent(TRACK_EVENT.PAGE_VIEW, {
            event: TRACK_EVENT.PAGE_VIEW,
        });
    }, []);

    return (
        <>
            <PreloadResources trackingConfig={trackingConfig} />
            {generateGoogleAnalyticsScript(trackingConfig?.google_analytics_id)}
            {generateFacebookPixelScript(trackingConfig?.facebook_pixel_id)}
        </>
    );
}
